import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Grid } from "@mui/material";
import "./PermissionBlock.scss";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import { isValidRole } from "../../../../../utils/utils";
import BasicModal from "../../../../core/BaseComponents/Modal";

const PermissionBlock = (props) => {
  const { items } = props;
  const [showPopup, setShowPopup] = useState(false);
  const [data, setData] = useState();
  const closePopup = () => {
    setShowPopup(false);
  };
  return (
    <div className="col-md-12 px-0">
      {Object.keys(items).map((key) => {
        const item = items[key];
        const mod = props.permissions.find((p) => p.id === item.module);
        return (
          <div className="roles-permission-bg">
            <h4>{`${mod ? mod.permission : ""} Permission`}</h4>
              <Grid container spacing={1}>
                <Grid item xs={10}>
                  {item.selectedPermission.map((p) => {
                    if (p.checked) {
                      return (
                        <button className="update" key={p.id}>
                          {p.title}
                        </button>
                      );
                    }
                  })}
                </Grid>
                <Grid className="p-3 permission-action" xs={2}>
                  {isValidRole("EDIT_PERMISSIONS") ? (
                    <Tooltip title="Edit" arrow>
                      <span style={{ marginRight: 10 }}>
                        <ModeEditIcon
                          className="edit-icon"
                          onClick={() => props.updateHandler(item)}
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="" arrow>
                      <DeleteIcon className="metadataevent mr-2" />
                    </Tooltip>
                  )}
                  {isValidRole("EDIT_PERMISSIONS") ? (
                    <Tooltip title="Delete" arrow>
                      <span>
                        <DeleteIcon
                          className="edit-icon"
                          onClick={() => {
                            setShowPopup(true);
                            setData(item);
                          }}
                        />
                      </span>
                    </Tooltip>
                  ) : (
                    <Tooltip title="" arrow>
                      <DeleteIcon className="metadataevent mr-2" />
                    </Tooltip>
                  )}
                </Grid>
              </Grid>
          </div>
        );
      })}

      <BasicModal
          popupOpen={showPopup}
          bodyMessage={<> 
          <span className="d-block">
            <img src="/Images/delete.png" alt="Delete" style={{ width: 60 }} />
          </span>
          <p>Do you really want to Delete Permission?</p>
          </>
          }
          footer={
            {
              primaryButton: {
                buttonName: "Cancel",
                action: closePopup
              },
              secondaryButton: {
                buttonName: "Delete",
                action:() => {
                  setShowPopup(false);
                  props.deleteHandler(data);
                }
              }
            }
          }
        />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    permissions: state.permissionReducer.permissions,
  };
};

const mapDispatcherToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatcherToProps)(PermissionBlock);
